module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo02-3a7f082cad160f22343450c67be80a7a.jpg";